import React, { useState, useRef } from 'react';
import './Contact.css';
import { FaTwitter, FaFacebook, FaLinkedinIn } from 'react-icons/fa';
import useClickSound from '../../hooks/useClickSound';
import emailjs from 'emailjs-com';

const Contact = () => {
  const playClickSound = useClickSound();
  const form = useRef();
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    subject: '',
    message: ''
  });
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    // Clear error when user starts typing in a field
    if (formErrors[name]) {
      setFormErrors({
        ...formErrors,
        [name]: ''
      });
    }
  };

  const validateForm = () => {
    const errors = {};
    
    if (!formData.name.trim()) {
      errors.name = 'Name is required';
    }
    
    if (!formData.email.trim()) {
      errors.email = 'Email is required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formData.email)) {
      errors.email = 'Invalid email address';
    }
    
    if (!formData.message.trim()) {
      errors.message = 'Message is required';
    }
    
    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    playClickSound();
    
    const errors = validateForm();
    setFormErrors(errors);
    
    if (Object.keys(errors).length === 0) {
      setIsSubmitting(true);
      setSubmitStatus('sending');
      
      // Replace these with your actual EmailJS service details
      emailjs.sendForm(
        'YOUR_SERVICE_ID', // Replace with your EmailJS service ID
        'YOUR_TEMPLATE_ID', // Replace with your EmailJS template ID
        form.current,
        'YOUR_USER_ID' // Replace with your EmailJS user ID
      )
        .then((result) => {
          console.log('Email sent successfully:', result.text);
          setSubmitStatus('success');
          setFormData({
            name: '',
            phone: '',
            email: '',
            subject: '',
            message: ''
          });
          setTimeout(() => {
            setSubmitStatus(null);
          }, 5000);
        })
        .catch((error) => {
          console.error('Failed to send email:', error.text);
          setSubmitStatus('error');
          setTimeout(() => {
            setSubmitStatus(null);
          }, 5000);
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    }
  };

  const handleSocialClick = () => {
    playClickSound();
  };

  return (
    <section id="contact" className="contact-section container mt-5">
      <h2 className="section-title text-center mb-4">Contact Me</h2>
      <div className="row">
        
        {/* Left Side - Contact Information */}
        <div className="col-md-5">
          <div className="contact-card h-100">
            <img 
              src="https://images.pexels.com/photos/3182812/pexels-photo-3182812.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" 
              alt="Contact Profile" 
              className="contact-image" 
            />
            <div className="contact-info">
              <h3>Ade Sam</h3>
              <p className="title">Chief Operating Officer</p>
              <p className="description">Delivering exceptional solutions for your projects.</p>
              <p className="contact-detail"><strong>Phone:</strong> +27 63 323 5887</p>
              <p className="contact-detail"><strong>Email:</strong> adesam@iglam.co.za</p>
            </div>
            
            <div className="social-links">
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-link" onClick={handleSocialClick}><FaTwitter /></a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-link" onClick={handleSocialClick}><FaFacebook /></a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-link" onClick={handleSocialClick}><FaLinkedinIn /></a>
            </div>
          </div>
        </div>

        {/* Right Side - Contact Form */}
        <div className="col-md-7">
          <div className="contact-card h-100">
            <form ref={form} className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <div className="input-group">
                  <label>Your Name</label>
                  <input 
                    type="text" 
                    name="name" 
                    value={formData.name}
                    onChange={handleChange}
                    className={formErrors.name ? 'error' : ''}
                  />
                  {formErrors.name && <div className="error-message">{formErrors.name}</div>}
                </div>
                <div className="input-group">
                  <label>Phone Number</label>
                  <input 
                    type="text" 
                    name="phone" 
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="form-group">
                <div className="input-group">
                  <label>Email</label>
                  <input 
                    type="email" 
                    name="email" 
                    value={formData.email}
                    onChange={handleChange}
                    className={formErrors.email ? 'error' : ''}
                  />
                  {formErrors.email && <div className="error-message">{formErrors.email}</div>}
                </div>
              </div>
              <div className="form-group">
                <div className="input-group">
                  <label>Subject</label>
                  <input 
                    type="text" 
                    name="subject" 
                    value={formData.subject}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="form-group">
                <div className="input-group">
                  <label>Your Message</label>
                  <textarea 
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className={formErrors.message ? 'error' : ''}
                  ></textarea>
                  {formErrors.message && <div className="error-message">{formErrors.message}</div>}
                </div>
              </div>
              <button 
                type="submit" 
                className={`btn-submit card-effect ${isSubmitting ? 'disabled' : ''}`}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'SENDING...' : 'SEND MESSAGE'}
              </button>
              
              {submitStatus === 'success' && (
                <div className="status-message success">
                  Your message has been sent successfully!
                </div>
              )}
              
              {submitStatus === 'error' && (
                <div className="status-message error">
                  Failed to send message. Please try again later.
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
